import { IDocumentPackage } from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { Lozenge } from "@rentiohq/web-shared/dist/components";
import { getSignerInfo } from "utils/documentPackage.utils";
import { ts } from "../../../../services";
import * as documentPackageUtils from "../../../../utils/documentPackage.utils";

export const getDocumentPackageStatusLozenge = (params: {
  documentPackage: IDocumentPackage;
}) => {
  const { documentPackage } = params;

  const simpleStage =
    documentPackage.status &&
    documentPackageUtils.getSimpleStages(documentPackage.status);
  const { signedCount, signerCount } = getSignerInfo(documentPackage);

  const stageReadable = ts.followUpDocumentPackagesFilterStageLabel({
    extra: { key: simpleStage },
  });
  const signerCountReadable = `${signedCount}/${signerCount}`;

  return (
    <Lozenge
      isBold
      key={`${documentPackage.id}-document_package-status`}
      appearance={documentPackageUtils.getStatusStageVariation(
        documentPackage.status,
      )}
    >
      {`${stageReadable}: ${signerCountReadable}`}
    </Lozenge>
  );
};
